import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';
import { FORM_VALIDATION_ERRORS } from 'src/consts';

const { phone } = capsuleValidation;

const initialValues = {
  first_name: '',
  last_name: '',
  phone: '',
};

export type IntialValues = typeof initialValues;

const baseSchema = {
  first_name: Yup.string().required(FORM_VALIDATION_ERRORS.firstName),
  last_name: Yup.string().required(FORM_VALIDATION_ERRORS.lastName),
  phone: phone().required(FORM_VALIDATION_ERRORS.mobilePhone),
};

const schema = Yup.object().shape({ ...baseSchema });

const validation = {
  initialValues,
  schema,
};

export default validation;
